import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { SizeController } from '@adornis/chemistry/controllers/size-controller';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/file-utils/client/x-image';
import '@adornis/germanium/components/ge-button';
import '@adornis/germanium/fonts';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/**
 * @element wtg-blog-post-preview
 */
@customElement('wtg-blog-post-preview')
export class WTGBlogPostPreview extends ChemistryLitElement {
  @state() size = new SizeController(this);

  styles = () => ({
    ':host': {
      flex: '1',
      backgroundColor: 'white',
      minWidth: this.size.isMobile ? '' : '250px',
      flexBasis: '250px',
      boxShadow: `0px 2px 4px rgba(0, 0, 0, 0.075)`,
      borderRadius: this.sizes.borderRadius,
      overflow: 'hidden',
    },
  });

  @property({ reflect: true }) postID = '';
  @property({ reflect: true }) header = '';
  @property({ reflect: true }) text = '';
  @property({ reflect: true }) imageUrl = '';

  public render() {
    return html`
      <x-link
        href="/blog/post/${this.postID}"
        ${css({ height: '100%', width: '100%', minHeight: '400px', position: 'relative' })}
      >
        <x-flex ${css({ height: '100%', width: '100%' })}>
          <x-flex flex ${css({ height: '50%' })}>
            <x-image
              ?dummy=${!this.imageUrl}
              .value=${this.imageUrl}
              mode="cover"
              ${css({ height: '100%', width: '100%' })}
            ></x-image>
          </x-flex>
          <x-flex flex space-between ${css({ boxSizing: 'border-box', height: '50%' })}>
            <x-flex space="md" padding="lg">
              <ge-h4>${this.header || 'Kein Post verlinkt'}</ge-h4>
              <ge-mini flex grey>${this.text || 'hier kommt der header hin'}</ge-mini>
            </x-flex>

            <x-flex
              horizontal
              space="sm"
              crossaxis-center
              padding="lg"
              ${css({
                position: 'absolute',
                bottom: '0',
                left: '0',
                right: '0',
                background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 22%)',
              })}
            >
              <img
                ${css({
                  width: '20px',
                })}
                src=${require('client/assets/plus_square.svg')}
              />
              <ge-text> LEARN MORE </ge-text>
            </x-flex>
          </x-flex>
        </x-flex>
      </x-link>
    `;
  }
}
